const U = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&w=${w}&q=80`;
const P = (url, w = 1400) => `${url}?auto=compress&cs=tinysrgb&w=${w}`;

export const NAV_LINKS = [
  { label: "Who We Rep", href: "#represent" },
  { label: "For Brands", href: "#for-brands" },
  { label: "For Talent", href: "#for-talent" },
];

export const HERO_VIDEO = "/hero.mp4";
export const HERO_POSTER = U("photo-1587296104393-8db6cda4418d", 1920);

// WHO WE REPRESENT — large editorial categories
export const REPRESENT = [
  {
    no: "01",
    title: "Athletes",
    copy: "Professional and rising athletes building brands beyond the game.",
    image: U("photo-1574679626212-7d11aa571832"),
  },
  {
    no: "02",
    title: "Sports Creators",
    copy: "Creators shaping how the next generation watches, plays and talks sport.",
    image: P("https://images.pexels.com/photos/12882043/pexels-photo-12882043.jpeg"),
  },
  {
    no: "03",
    title: "Entertainers & Comedy",
    copy: "Personality-driven talent who turn attention into a room they own.",
    image: U("photo-1615754890634-69ac8bca7189"),
  },
  {
    no: "04",
    title: "Digital Personalities",
    copy: "Culturally relevant voices with real reach and real influence.",
    image: U("photo-1567007913895-95bdc38b530f"),
  },
];

// TALENT — premium roster "player cards" (clearly-marked placeholders)
export const ROSTER = [
  {
    id: 1,
    category: "Football",
    platforms: ["Instagram", "TikTok", "YouTube"],
    audience: "2.4M+",
    image: U("photo-1521504846809-c3746c1fbf67"),
  },
  {
    id: 2,
    category: "Combat Sports",
    platforms: ["Instagram", "TikTok"],
    audience: "1.1M+",
    image: U("photo-1703837543381-5545225438a7"),
  },
  {
    id: 3,
    category: "Basketball",
    platforms: ["Instagram", "YouTube"],
    audience: "890K+",
    image: U("photo-1600985366045-c20ec2d3298a"),
  },
  {
    id: 4,
    category: "Comedy & Personality",
    platforms: ["TikTok", "Instagram"],
    audience: "3.2M+",
    image: U("photo-1542992933-ce75d0187ec1"),
  },
];

export const BRAND_HIGHLIGHTS = [
  "Brand Campaigns",
  "Ambassadorships",
  "Social Partnerships",
  "Appearances",
  "Content Collaborations",
  "Long-Term Partnerships",
];

export const TALENT_SERVICES = [
  { no: "01", title: "Brand Opportunities", copy: "Access to campaigns, deals and partners that fit your world." },
  { no: "02", title: "Negotiations", copy: "We handle the numbers, the terms and the fine print, so you don't have to." },
  { no: "03", title: "Partnership Strategy", copy: "Deals structured for the long game, not just the next post." },
  { no: "04", title: "Career Development", copy: "Building careers that extend far beyond the feed." },
  { no: "05", title: "Positioning", copy: "A clear identity that brands and audiences recognise instantly." },
  { no: "06", title: "Relationship Management", copy: "One team managing every partner, every conversation, every day." },
];

// Logo strip — real brand logos, normalised to warm-white transparent PNGs.
export const BRAND_STRIP = [
  { name: "Warner Bros", src: "/logos/warner.png", h: 48 },
  { name: "Netflix", src: "/logos/netflix.png", h: 46 },
  { name: "Sony", src: "/logos/sony.png", h: 26 },
  { name: "Beats", src: "/logos/beats.png", h: 46 },
  { name: "Old Navy", src: "/logos/oldnavy.png", h: 40 },
  { name: "Hollister", src: "/logos/hollister.png", h: 46 },
  { name: "DFYNE", src: "/logos/dfyne.png", h: 26 },
  { name: "White Fox", src: "/logos/whitefox.png", h: 24 },
  { name: "Goli Nutrition", src: "/logos/goli.png", h: 40 },
  { name: "Temu", src: "/logos/temu.png", h: 30 },
  { name: "Scuffers", src: "/logos/scuffers.png", h: 40 },
];
